import React, { useEffect, useRef, useState } from 'react'
import {
    I2cRadioGroup,
    I2cRadioButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { fields, fieldsArray, validationSchema } from "./ValidationSchema.jsx";
import ManageOutsideI2cPlatform from './ManageOutsideI2cPlatform.jsx';
import ManageInsideI2cPlatform from './ManageInsidei2cPlatform.jsx';
import CheckboxRenderer from './CustomHeaderCheckbox.jsx';

import {
    enrollment_Type, shippingMethod, loginInfo, accountInfo, additionalCardInfo,
    documentationInfo, employeeInfo, businessOwnerInfo, businessInfo,
    business_loginInfo, business_accountInfo, business_additionalCardInfo,
    business_documentationInfo, business_employeeInfo, business_businessOwnerInfo,
    business_businessInfo, consumer_loginInfo, consumer_personalInfo, consumer_sourceOfIncomeInfo,
    consumer_documentary_proof, consumer_identification_details
} from './stringUtils';
const CardEnrollment = ({
    type,
    setAddFormData,
    addFormData,
    setFormValidStates,
    formDataJson,
    isFetching,
}) => {
    const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
    const checkboxRef = useRef(null);
    const [isFormDataUpdated, setIsFormDataUpdated] = useState(false);
    const [fileJson, setFileJson] = useState([]);
    const state = type === "credit" ? "3_0" : "4_0"
    // Initialize React Hook Form with Yup resolver
    const methods = useForm({
        resolver: yupResolver(validationSchema),
        mode: "all",
        reValidateMode: "all",
        shouldUseNativeValidation: false,
        criteriaMode: "all",
        defaultValues: {
            card_enrollment_manage_enrollment_type: "Manage enrollment outside i2c platform",
            card_enrollment_link_enrollment_platform_to_i2c: "Yes",
            card_enrollment_card_enrollment_url_type: "Custom URL",
            card_enrollment_card_enrollment_url: "",
            card_enrollment_url_platform: [],
            card_enrollment_card_account_type: "",
            card_enrollment_category_consumer_link_platform_to_i2c: "No",
            card_enrollment_category_consumer_title_for_enrollment_screen: "",
            card_enrollment_category_consumer_description_for_enrollment_screen: "",
            card_enrollment_category_business_link_platform_to_i2c: "No",
            card_enrollment_category_business_title_for_enrollment_screen: "",
            card_enrollment_category_business_description_for_enrollment_screen: "",
            card_enrollment_category_corporate_link_platform_to_i2c: "No",
            card_enrollment_category_corporate_title_for_enrollment_screen: "",
            card_enrollment_category_corporate_description_for_enrollment_screen: "",
            card_enrollment_card_product_groups: [{
                images_file: [],
                count: "",
                title: "",
                description: "",
            },],
            card_enrollment_consumer_credit_card: "Secured",
            card_enrollment_create_user_during_enrollment: "Yes",
            card_enrollment_customer_email_as_user_id: "No",
            card_enrollment_show_email_id_on_screen: "No",
            //Corporate tab
            card_enrollment_fields_for_corporate_account_info: accountInfo,
            card_enrollment_fields_for_corporate_additional_card_info: additionalCardInfo,
            card_enrollment_fields_for_corporate_documentation: documentationInfo,
            card_enrollment_fields_for_corporate_employee_info: employeeInfo,
            card_enrollment_fields_for_corporate_business_owner_info: businessOwnerInfo,
            card_enrollment_fields_for_corporate_business_info: businessInfo,
            card_enrollment_fields_for_corporate_login_info: loginInfo,
            //business tab
            card_enrollment_fields_for_business_account_info: business_accountInfo,
            card_enrollment_fields_for_business_additional_card_info: business_additionalCardInfo,
            card_enrollment_fields_for_business_documentation: business_documentationInfo,
            card_enrollment_fields_for_business_employee_info: business_employeeInfo,
            card_enrollment_fields_for_business_business_owner_info: business_businessOwnerInfo,
            card_enrollment_fields_for_business_business_info: business_businessInfo,
            card_enrollment_fields_for_business_login_info: business_loginInfo,
            // consumer tab
            card_enrollment_fields_for_consumer_source_of_income_info: consumer_sourceOfIncomeInfo,
            card_enrollment_fields_for_consumer_personal_info: consumer_personalInfo,
            card_enrollment_fields_for_consumer_login_info: consumer_loginInfo,
            card_enrollment_fields_for_consumer_documentary_proof_info: consumer_documentary_proof,
            card_enrollment_fields_for_consumer_identification_info: consumer_identification_details,

            card_enrollment_agreement_for_customer_acceptance: "Yes",
            card_enrollment_agreement_type_for_common_toggle: "",
            card_enrollment_agreement_type: "Use Customized Content",
            card_enrollment_agreement_external_content_url: "",
            card_enrollment_agreement_customized_content_file: [],
            card_enrollment_funding_option: [],
            card_enrollment_funding_option_payment_gateway: "",
            card_enrollment_funding_option_payment_gateway_other: "",
            card_enrollment_shipping_method: shippingMethod,

        },
    });

    useEffect(() => {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
            if (type === "credit") {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_0"][field] ?? "");
                });
                fieldsArray.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_0"][field] ?? []);
                });
                setFileJson(formDataJson[3]["3_0"])
            }
            else {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[4]["4_0"][field] ?? "");
                });
                fieldsArray.forEach((field) => {
                    methods.setValue(field, formDataJson[4]["4_0"][field] ?? []);
                });
                setFileJson(formDataJson[4]["4_0"])
            }
            methods.trigger();
            handleValueChanges();
            setIsFormDataUpdated(true);
        }
    }, [isFetching]);
    // Controlls destructuring from the method

    const {
        control,
        formState: { errors },
    } = methods;

    // Trigger validation when component mounts
    React.useEffect(() => {
        methods.trigger();
    }, []);

    const handleValueChanges = () => {
        const values = methods.getValues();
        if (type === "credit") {
            setAddFormData({
                ...addFormData,
                3: {
                    ...addFormData["3"],
                    "3_0": { ...values },
                },
            });
        }
        else {
            setAddFormData({
                ...addFormData,
                4: {
                    ...addFormData["4"],
                    "4_0": { ...values },
                },
            });
        }

    };
    //to reset values on change 
    const resetFormFields = (enrollmentType, methods) => {
        const isExternalEnrollment = enrollmentType === "Manage enrollment outside i2c platform";
      
        // Common fields to reset for both cases
        const commonResetFields = {
          card_enrollment_url_platform: [],
          card_enrollment_card_enrollment_url_type: "",
          card_enrollment_card_enrollment_url: "",
        };
      
        if (!isExternalEnrollment) {
          // Reset fields when i2c manages enrollment
          methods.setValue("card_enrollment_link_enrollment_platform_to_i2c", "");
          Object.entries(commonResetFields).forEach(([key, value]) => methods.setValue(key, value));
        } else {
          // Reset fields for external enrollment
          const externalResetFields = {
            ...commonResetFields,
            card_enrollment_card_account_type: "",
            card_enrollment_card_product_groups: [{
              images_file: [],
              count: "",
              title: "",
              description: "",
            }],
            card_enrollment_category_consumer_link_platform_to_i2c: "",
            card_enrollment_category_consumer_title_for_enrollment_screen: "",
            card_enrollment_category_consumer_description_for_enrollment_screen: "",
            card_enrollment_category_business_link_platform_to_i2c: "",
            card_enrollment_category_business_title_for_enrollment_screen:"",
            card_enrollment_category_business_description_for_enrollment_screen: "",
            card_enrollment_category_corporate_link_platform_to_i2c: "",
            card_enrollment_category_corporate_title_for_enrollment_screen: "", 
            card_enrollment_category_corporate_description_for_enrollment_screen: "",
            card_enrollment_agreement_type_for_common_toggle: "",
            card_enrollment_agreement_type: "",
            card_enrollment_agreement_customized_content_file: [],
            card_enrollment_agreement_external_content_url: "",
            // Corporate tab
            card_enrollment_fields_for_corporate_account_info: accountInfo,
            card_enrollment_fields_for_corporate_additional_card_info: additionalCardInfo,
            card_enrollment_fields_for_corporate_documentation: documentationInfo,
            card_enrollment_fields_for_corporate_employee_info: employeeInfo,
            card_enrollment_fields_for_corporate_business_owner_info: businessOwnerInfo,
            card_enrollment_fields_for_corporate_business_info: businessInfo,
            card_enrollment_fields_for_corporate_login_info: loginInfo,
            // Business tab
            card_enrollment_fields_for_business_account_info: business_accountInfo,
            card_enrollment_fields_for_business_additional_card_info: business_additionalCardInfo,
            card_enrollment_fields_for_business_documentation: business_documentationInfo,
            card_enrollment_fields_for_business_employee_info: business_employeeInfo,
            card_enrollment_fields_for_business_business_owner_info: business_businessOwnerInfo,
            card_enrollment_fields_for_business_business_info: business_businessInfo,
            card_enrollment_fields_for_business_login_info: business_loginInfo,
            // Consumer tab
            card_enrollment_fields_for_consumer_source_of_income_info: consumer_sourceOfIncomeInfo,
            card_enrollment_fields_for_consumer_personal_info: consumer_personalInfo,
            card_enrollment_fields_for_consumer_login_info: consumer_loginInfo,
            card_enrollment_fields_for_consumer_documentary_proof_info: consumer_documentary_proof,
            card_enrollment_fields_for_consumer_identification_info: consumer_identification_details,
          };
      
          Object.entries(externalResetFields).forEach(([key, value]) => methods.setValue(key, value));
        }
      };
      console.log("error in card enrollment", errors);
    // Update form validation state when errors change
    React.useEffect(() => {
        const errorsLength = Object.keys(errors)?.length;
        if (type === "credit") {
            if (errorsLength === 0) setFormValidStates("3_0", true);
            else setFormValidStates("3_0", false);
        }
        else {
            if (errorsLength === 0) setFormValidStates("4_0", true);
            else setFormValidStates("4_0", false);
        }

    }, [Object.keys(errors)?.length]);

    return (
        <React.Fragment>
            <div className="forms-instance">

                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            Enrollment Management
                        </div>
                        <div className="custom-label">
                            This section lists i2c’s enrollment service which enables cardholders to order and purchase cards online.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="card_enrollment_manage_enrollment_type"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        label="Please confirm if you want i2c to manage the enrollment or want to manage the enrollment outside of the i2c platform"
                                        {...field}
                                        name="card_enrollment_manage_enrollment_type"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            methods.trigger();
                                            handleValueChanges();
                                            setIsFormDataUpdated(prev => !prev);
                                            resetFormFields(e.target.value, methods);

                                        }}
                                    >
                                        {enrollment_Type.map((eT, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("card_enrollment_manage_enrollment_type") === eT
                                                }
                                                value={eT}
                                            >
                                                {eT}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>

                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.card_enrollment_manage_enrollment_type &&
                                        methods.formState.touchedFields.card_enrollment_manage_enrollment_type
                                        ? true
                                        : false
                                }
                                message={errors.card_enrollment_manage_enrollment_type?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {
                        methods.watch("card_enrollment_manage_enrollment_type") === "Manage enrollment outside i2c platform" && (
                            <ManageOutsideI2cPlatform
                                type={type}
                                control={control}
                                handleValueChanges={handleValueChanges}
                                methods={methods}
                                errors={errors}
                            />
                        )
                    }

                </div>
                {
                    methods.watch("card_enrollment_manage_enrollment_type") === "Manage enrollment through i2c platform" && (
                        <ManageInsideI2cPlatform
                            type={type}
                            control={control}
                            handleValueChanges={handleValueChanges}
                            methods={methods}
                            errors={errors}
                            appSelectionForProgram={appSelectionForProgram}
                            isFormDataUpdated={isFormDataUpdated}
                            fileJson={fileJson}
                            setFormValidStates={setFormValidStates}
                            state={state}
                        />
                    )
                }
            </div>
        </React.Fragment>
    )
}
export default CardEnrollment;